export const PAGE_NAME = 'follow-up-automations'

export const MESSAGE_MAX_LENGTH = 2000

export const DELAY_OPTIONS = [0, 1, 2, 3, 5, 7, 14, 30]

export const RULE_COPY = {
  CANCELED: {
    title: 'Canceled a booking',
    when: "after a student cancels and hasn't rebooked",
  },
  NEW: {
    title: 'First-time students',
    when: 'after a first lesson when nothing else is booked',
  },
  DUE: {
    title: 'Due to rebook',
    when: 'after a student passes their usual booking pace',
  },
  LAPSED: {
    title: 'Lapsed students',
    when: 'after a student stops booking for a long time',
  },
}

export const resultTitle = trigger =>
  RULE_COPY[trigger]?.title ?? 'Other follow-ups you sent'

export const formatDelay = days => {
  if (days === 0) return 'Right away'
  if (days === 1) return '1 day'
  return `${days} days`
}

export const describeRule = (trigger, delayDays) => {
  const { when } = RULE_COPY[trigger]
  if (delayDays === 0) return `Sends right away ${when}.`
  return `Sends ${formatDelay(delayDays)} ${when}.`
}

export const lowerFirst = text => text.charAt(0).toLowerCase() + text.slice(1)
